document.addEventListener('DOMContentLoaded', () => {
  initShowMore();
  initAlertClose();
  initClickableCards();
  initBasketCounter();
});

// Show more tickets
function initShowMore() {
  const buttons = document.querySelectorAll(".show-more-button");
  if (!buttons.length) return;

  buttons.forEach(button => {
    const container = button.closest(".tickets__list");
    if (!container) return;

    const items = container.querySelectorAll(".ticket-card");

    // Prevent page from scrolling after clicking on link
    items.forEach(item => {
      item.addEventListener("click", function (e) {
        const link = e.target.closest("a");
        if (link) {
          const href = link.getAttribute("href");

          if (!href || href === "#") {
            e.preventDefault();
          }
          return;
        }
      });
    });

    // Hide button in case lower amount of dates
    if (items.length <= 5) {
      button.style.display = "none";
      return;
    }

    button.addEventListener("click", function (event) {
      event.preventDefault();
      items.forEach(el => el.style.display = "flex");
      button.style.display = "none";
    });
  });
}

// Close alert
function initAlertClose() {
  const closeBtn = document.querySelector(".alert-close-btn");
  const alertWrapper = document.querySelector(".alert-wrapper");

  if (!closeBtn || !alertWrapper) return;

  closeBtn.addEventListener("click", () => {
    alertWrapper.style.display = "none";
  });
}

// Show card link
function initClickableCards() {
  const cards = document.querySelectorAll('.show-card-component');
  if (!cards.length) return;

  cards.forEach(card => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;

      const url = card.dataset.href;
      if (url) {
        window.location.href = url;
      }
    });

    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        const url = card.dataset.href;
        if (url) {
          window.location.href = url;
        }
      }
    });
  });
}

// Basket counter 
function initBasketCounter() {
  const wrapper = document.querySelector(".text-basket-count");
  const valueSpan = wrapper?.querySelector(".basm_basket_count");
  if (!valueSpan || !wrapper) return;

  const checkAndToggle = () => {
    const value = parseInt(valueSpan.textContent.trim(), 10);
    if (value >= 1) {
      wrapper.classList.remove("is-hidden");
    } else {
      wrapper.classList.add("is-hidden");
    }
  };

  checkAndToggle();

  const observer = new MutationObserver(checkAndToggle);
  observer.observe(valueSpan, { childList: true, subtree: true });
}